import React from "react";
import { Link, useNavigate } from "react-router-dom";

export default function TermsOfService() {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
            <div className="bg-white max-w-4xl w-full rounded-2xl shadow-xl p-10 animate-fade-in relative">
                <button
                    onClick={() => navigate(-1)}
                    className="absolute top-6 right-6 text-gray-400 hover:text-blue-600 transition-colors"
                >
                    <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                </button>

                <h1 className="text-4xl font-bold text-gray-800 mb-6 border-b pb-4">Terms of Service</h1>
                <p className="text-sm text-gray-500 mb-8">Effective Date: December 2025</p>

                <div className="space-y-8 text-gray-700 leading-relaxed">
                    <section>
                        <h2 className="text-2xl font-bold text-gray-800 mb-3">1. Acceptance of Terms</h2>
                        <p>By creating an account and using our service, you agree to these terms. If you do not agree, strictly do not use our services.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-800 mb-3">2. User Responsibilities</h2>
                        <p>You are responsible for your account security:</p>
                        <ul className="list-disc ml-6 mt-2 space-y-1">
                            <li><strong>Password:</strong> Your password encrypts your private key. If you forget your password, you may lose access to your past encrypted messages forever. We cannot recover them for you.</li>
                            <li><strong>Content:</strong> Do not upload illegal, harmful, or abusive content. We reserve the right to ban users who violate this policy.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-800 mb-3">3. Service Limitations</h2>
                        <p>We strive for 100% uptime, but our service is provided "as is". We are not liable for any data loss, message delivery failures, or downtime caused by our third-party infrastructure providers.</p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-800 mb-3">4. Security & Encryption Disclaimer</h2>
                        <p>While we use strong End-to-End Encryption (AES-GCM, RSA-OAEP) to protect your text messages and files:</p>
                        <ul className="list-disc ml-6 mt-2 space-y-1">
                            <li>No system is unhackable. Use this app for personal communication, but do not use it for state secrets or highly sensitive financial data.</li>
                            <li><strong>Data Security:</strong> Your data is encrypted, but you are responsible for keeping your physical device and password secure.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold text-gray-800 mb-3">5. Termination</h2>
                        <p>We reserve the right to suspend or terminate your account at any time if you violate these terms or if legally required to do so.</p>
                    </section>
                </div>

                <div className="mt-10 pt-6 border-t border-gray-100 text-center">
                    <button
                        onClick={() => navigate(-1)}
                        className="inline-block bg-green-600 text-white font-bold py-3 px-8 rounded-full hover:bg-green-700 transition-transform hover:scale-105 shadow-lg"
                    >
                        I Agree
                    </button>
                </div>
            </div>
        </div>
    );
}
